import { Component, OnInit, OnChanges, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { TeamQueueEdit, TeamQueueEditAbstractInformation } from '../../../../models/team/team-queue-edit.model';

import { DragDropModule, CdkDragDrop, moveItemInArray, CdkDropList, CdkDrag } from '@angular/cdk/drag-drop';
import { cursorTo } from 'readline';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DecisionBottomSheetComponent } from '../../../bottom-sheet/decision-bottom-sheet/decision-bottom-sheet.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-manage-queue-edit',
  templateUrl: './manage-queue-edit.component.html',
  styleUrls: ['./manage-queue-edit.component.css'],
  imports: [
    CommonModule,
    MatButtonModule,
    CdkDropList,
    CdkDrag
  ]
})
export class ManageQueueEditComponent implements OnInit, OnChanges {
  @Input() model: TeamQueueEdit
  @Input() isUpdating: boolean = false;
  @Input() hasUnsavedChanges: boolean = false;
  @Output() modelChange = new EventEmitter<TeamQueueEdit>();
  @Output() saveChanges = new EventEmitter<boolean>();
  @Output() errorMessage = new EventEmitter<string>();
  @Output() unsavedChanges = new EventEmitter<boolean>();


  constructor(private bottomSheet: MatBottomSheet) { }

  //isUpdating: boolean = false;

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("Received OnChanges for ManageQueueEdit");

    console.log(changes);

    for (let propName in changes)
      if (propName == "model")
        this.model = changes[propName].currentValue;
      else if (propName == "isUpdating")
        this.isUpdating = changes[propName].currentValue;

    if(this.model)
      this.updateSorting(this.model.queue, false);
  }

  updateModel(value: TeamQueueEdit) {
    this.model = value;
    this.modelChange.emit(value);
  }

  clearQueue() {
    this.bottomSheet.open(DecisionBottomSheetComponent, {
      data: {
        sheetTitle: "Clear Queue",
        sheetHtml: "Are you sure you want to clear the queue? Changes must be saved afterward to apply, and in-progress items will NOT be removed."
      }
    }).afterDismissed().subscribe(isOk => {
      if (isOk) {
        var newQueue = [];

        for (var i = 0; i < this.model.queue.length; i++)
          if (!this.model.queue[i].canBeRemoved)
            newQueue.push(this.model.queue[i]);

        this.model.queue = newQueue ;
        this.updateModel(this.model);
        this.updateUnsavedChanges(true);
      }
    });
  }

  submitQueue() {
    this.saveChanges.emit(true);
  }

  updateUnsavedChanges(unsaved: boolean) {
    this.unsavedChanges.emit(unsaved);
  }

  removeItem($event, title: string, canBeRemoved: boolean) {
    $event.stopPropagation();
    if (canBeRemoved) {

      this.bottomSheet.open(DecisionBottomSheetComponent, {
        data: {
          sheetTitle: `Remove Item: ${title}`,
          sheetHtml: `Are you sure you want to remove &nbsp;<b>${title}</b>&nbsp; from the queue? Changes must be saved afterward to apply.`
        }
      }).afterDismissed().subscribe(isOk => {
        if (isOk) {
          for (var i = 0; i < this.model.queue.length; i++) {
            if (this.model.queue[i].title == title) {
              this.model.queue.splice(i, 1);
              break;
            }
          }
          this.updateModel(this.model);
          this.updateUnsavedChanges(true);
        }
      });
    }

    return false;
  }
  
  drop(event: CdkDragDrop<TeamQueueEditAbstractInformation[]>) {
    if (this.model.queue[event.currentIndex]) {
      if (this.model.queue[event.currentIndex].canBeRemoved) {
        moveItemInArray(this.model.queue, event.previousIndex, event.currentIndex);
        this.updateSorting(this.model.queue);
        this.updateUnsavedChanges(true);
      }
      else {
        this.errorMessage.emit("Cannot sort above an in-progress abstract group. Change has been reverted.");
      }
    } 
  }

  updateSorting(array: TeamQueueEditAbstractInformation[], callUpdate: boolean = true) {
    var curSort: number = 1;
    var prevIndex: number = 0;

    //console.log(array);

    for (var i = 0; i < array.length; i++) {
      if (i > prevIndex) {
        curSort += array[prevIndex].numberInGroup;

        array[i].sorting = curSort;
      }
      else {
        array[i].sorting = 1;
      }

      prevIndex = i;
    }

    //console.log(array);
    if(callUpdate)
      this.updateModel(this.model);
  }
}
